import React from 'react';
import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';

function SearchComponent({ searchQuery, setSearchQuery, onSearchClick, onClearSearch }) {
  const handleInputChange = (event) => {
    setSearchQuery(event.target.value);
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      onSearchClick();
    }
  };

  return (
    <div style={{ padding: '16px', display: 'flex', alignItems: 'center' }}>
      <TextField
        label="Search"
        variant="outlined"
        value={searchQuery}
        onChange={handleInputChange}
        onKeyDown={handleKeyDown}
        style={{ marginRight: '16px', flexGrow: 1 }}
      />
      <IconButton
        onClick={onSearchClick}
        color="primary"
        disabled={!searchQuery}
      >
        <SearchIcon />
      </IconButton>
      <IconButton
        onClick={onClearSearch}
        color="secondary"
        disabled={!searchQuery}
      >
        <ClearIcon />
      </IconButton>
    </div>
  );
}

export default SearchComponent;
